import { render } from "./MintWidget.vue?vue&type=template&id=ff7cbf66&ts=true"
import script from "./MintWidget.vue?vue&type=script&lang=ts"
export * from "./MintWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__